import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TrackApiService, TrackApiServiceImpl } from '@/infrastructure/api-functions/track-api-service'
import { TrackService, TrackServiceImpl } from '@/services/track-service';

export const trackModule = new ContainerModule((bind) => {
    bind(TrackApiService).to(TrackApiServiceImpl);
    bind(TrackService).to(TrackServiceImpl)
});
